export enum ProfileMenuClickActionType {
  MyProfile = 1,
  Export = 2,
  Import = 3,
}
